import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Label,
  Input,
} from 'reactstrap';
import _ from 'lodash';
import { useIntl } from 'react-intl';

import { APIgetGroups } from '../../../api/Group';
import { APIgetRoles } from '../../../api/Roles';

import { getBuiltInRoles } from '../../../helpers/Users';

import LoadingSmall from '../../LoadingSmall';
import ErrorBoundary from '../../ErrorBoundary';

const CapabilitiesAddUsersSettings = ({
  capabilityAttributes,
  handleChangeCapabilityAttributes,
}) => {
  const [roles, setRoles] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const builtInRoles = _.sortBy(getBuiltInRoles().map(role => ({
      id: role.value,
      name: role.label,
      description: role.description,
    })), 'id');
    const fetchRolesAndTeams = async () => {
      setError(null);
      setLoading(true);
      try {
        const response = await APIgetRoles({ all: true });
        setRoles(builtInRoles.concat(response.data));
      } catch (e) {
        setError(e);
      }
      try {
        const response = await APIgetGroups({ all: true });
        setTeams(response.data);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchRolesAndTeams();
  }, []);

  const intl = useIntl();

  let {
    roles: selectedRoles = [],
    teams: selectedTeams = [],
  } = capabilityAttributes || {};

  const handleChangeRoles = (e) => {
    const {
      checked,
      value,
    } = e.target;
    let newSelectedRoles = [...selectedRoles];

    if (checked) {
      newSelectedRoles.push(value);
    } else {
      newSelectedRoles = newSelectedRoles.filter(rid => `${rid}` !== value);
    }

    selectedRoles = newSelectedRoles;
    handleChangeCapabilityAttributes('add_users', { roles: selectedRoles, teams: selectedTeams });
  };

  const handleChangeTeams = (e) => {
    const {
      checked,
      value,
    } = e.target;
    let newSelectedTeams = [...selectedTeams];

    if (checked) {
      newSelectedTeams.push(value);
    } else {
      newSelectedTeams = newSelectedTeams.filter(tid => tid !== value);
    }

    selectedTeams = newSelectedTeams;
    handleChangeCapabilityAttributes('add_users', { roles: selectedRoles, teams: selectedTeams });
  };

  return (
    <ErrorBoundary>
      {loading ? (
        <LoadingSmall />
      ) : (
        <div className="capabilities-add-users-settings-list">
          <p>
            {intl.formatMessage({ defaultMessage: 'Select roles and teams this role should be able to add users to' })}
          </p>
          {error && (
            <p className="error">
              {intl.formatMessage({ defaultMessage: 'Something went wrong' })}
            </p>
          )}
          <h4>
            {intl.formatMessage({ defaultMessage: 'Roles' })}
          </h4>
          <div className="capabilities-add-users-settings-list-roles">
            {roles.length === 0 && (
              <p>
                {intl.formatMessage({ defaultMessage: 'No roles found' })}
              </p>
            )}
            {roles.map(role => (
              <Label key={role.id} for={`switch-role-${role.id}`} className="switch">
                <div className="switch-details">
                  <span>{role.name}</span>
                </div>
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    name="groupUploadFile"
                    id={`switch-role-${role.id}`}
                    value={`${role.id}`}
                    defaultChecked={selectedRoles.includes(role.id)}
                    onChange={handleChangeRoles}
                  />
                  <i />
                </div>
              </Label>
            ))}
          </div>
          <h4>
            {intl.formatMessage({ defaultMessage: 'Teams' })}
          </h4>
          <div className="capabilities-add-users-settings-list-teams">
            {teams.length === 0 && (
              <p>
                {intl.formatMessage({ defaultMessage: 'No teams found' })}
              </p>
            )}
            {teams.map(team => (
              <Label key={team.uuid} for={`switch-team-${team.uuid}`} className="switch">
                <div className="switch-details">
                  <span>{team.name}</span>
                </div>
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    name="groupUploadFile"
                    id={`switch-team-${team.uuid}`}
                    value={team.uuid}
                    defaultChecked={selectedTeams.includes(team.uuid)}
                    onChange={handleChangeTeams}
                  />
                  <i />
                </div>
              </Label>
            ))}
          </div>
        </div>
      )}
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  selectedFiles: state.Files.selectedFiles,
  selectedCollections: state.Collections.selectedCollections,
  fileModalOpen: state.Files.fileModalOpen,
  uploadModal: state.Files.uploadModal,
});

CapabilitiesAddUsersSettings.propTypes = {
  capabilityAttributes: PropTypes.object.isRequired,
  handleChangeCapabilityAttributes: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(CapabilitiesAddUsersSettings);
